import { defineMessages } from 'react-intl';

export const messages: {
	error_boundary_fallback_text: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	error_boundary_fallback_text: {
		id: 'search_ai.error_boundary_fallback_text',
		defaultMessage: 'Something went wrong. Try refreshing the page or trying again later.',
		description: 'Fallback text for the error boundary fallback component',
	},
});
